import type { WhitelabelVariantDefinition } from '../../types';

export const beedigitalWhitelabel = {
  id: 'bee-ddt',
  colors: {
    primary: {
      900: '#53138A',
      800: '#60169F',
      700: '#801DD4',
      500: '#A35CE0',
      300: '#CCA5EE',
      100: '#F2E8FB',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const beedigitalDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: beedigitalWhitelabel.colors.primary[900],
      dark: beedigitalWhitelabel.colors.primary[800],
      main: beedigitalWhitelabel.colors.primary[700],
      light: beedigitalWhitelabel.colors.primary[500],
      lighter: beedigitalWhitelabel.colors.primary[300],
      muted: beedigitalWhitelabel.colors.primary[100],
      contrastText: beedigitalWhitelabel.colors.primary.contrastText,
    },
  },
};
